import { render, staticRenderFns } from "./hotelInfoScreen.vue?vue&type=template&id=9368ec98&scoped=true&"
import script from "./hotelInfoScreen.vue?vue&type=script&lang=js&"
export * from "./hotelInfoScreen.vue?vue&type=script&lang=js&"
import style0 from "./hotelInfoScreen.vue?vue&type=style&index=0&id=9368ec98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9368ec98",
  null
  
)

export default component.exports